import React from 'react';

import ButtonDropdown from '../../../common2/ButtonDropdown/ButtonDropdown';
import MenuItem from '../../../common2/DropdownButton/MenuItem';
import Locale from '../../../Translate/Locale';
import LinkIcon from '../../../../icons/link.svg';
import DORSigningLinkModal from './DORSigningLinkModal';

type DORSigningLinkButtonProps = {
  languages: Array<{ key: string; value: string }>;
  shipmentId: number;
  recipientEmail: string;
};

function DORSigningLinkButton(props: DORSigningLinkButtonProps) {
  const { languages, shipmentId, recipientEmail } = props;
  const [selectedLanguage, setSelectedLanguage] = React.useState<string | null>(null);
  const [showModal, setShowModal] = React.useState(false);

  const handleLanguageSelection = (language: string) => {
    if (language !== selectedLanguage) {
      setSelectedLanguage(language);
    }

    setShowModal(true);
  };

  const onCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <ButtonDropdown icon={LinkIcon} text={'DOR signing link'}>
        {languages.map(({ key: language, value: label }) => (
          <MenuItem key={language} selected={false} onClick={() => handleLanguageSelection(language)}>
            <Locale>{label}</Locale>
          </MenuItem>
        ))}
      </ButtonDropdown>
      <DORSigningLinkModal
        key={`${shipmentId}-${selectedLanguage}`}
        shipmentId={shipmentId}
        defaultRecipientEmail={recipientEmail}
        show={showModal}
        onClose={onCloseModal}
        selectedLanguage={selectedLanguage}
      />
    </>
  );
}

export default React.memo(DORSigningLinkButton);
